import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultLayoutComponent } from '@base/components/layout/default-layout/default-layout.component';
import { UserRoute } from '@core/constants/routes.const';
import { AuthGuardService } from '@core/services/auth-guard.service';
import { GuestGuardService } from '@core/services/guest-guard.service';
import { UsaCountryGuardService } from '@core/services/usa-country-guard.service';
import { UserFeatureGuardService } from '@core/services/user-feature-guard.service';
import { AccountComponent } from '@user/components/account/account.component';
import { AddressesComponent } from '@user/components/account/addresses/addresses.component';
import { OrderDetailsComponent } from '@user/components/account/orders/order-details/order-details.component';
import { OrdersComponent } from '@user/components/account/orders/orders.component';
import { PaymentMethodsComponent } from '@user/components/account/payment-methods/payment-methods.component';
import { RecipesComponent } from '@user/components/account/recipes/recipes.component';
import { ReturnsComponent } from '@user/components/account/returns/returns.component';
import { WishlistComponent } from '@user/components/account/wishlist/wishlist.component';
import { RegistrationComponent } from '@user/components/registration/registration.component';
import { AddressEditorComponent } from './components/account/addresses/address-editor/address-editor.component';
import { CcOrderDetailsComponent } from './components/account/orders/cc-order-details/cc-order-details.component';
import { CreatePaymentMethodComponent } from './components/account/payment-methods/create-payment-method/create-payment-method.component';
import { ProfileComponent } from './components/account/profile/profile.component';
import { NewReturnComponent } from './components/account/returns/new-return/new-return.component';
import { ReturnDetailsPageComponent } from './components/account/returns/return-details-page/return-details-page.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {
        path: UserRoute.Registration,
        component: RegistrationComponent,
        canActivate: [GuestGuardService, UserFeatureGuardService],
        data: {
          title: $localize`PH - Registration Page - Title`,
        },
      },
      {
        path: UserRoute.MyAccount,
        component: AccountComponent,
        children: [
          {
            path: UserRoute.Profile,
            component: ProfileComponent,
            data: { title: $localize`PH - Profile Page - Title` },
          },
          {
            path: UserRoute.Profile + '/:mobileUser',
            component: ProfileComponent,
            data: { title: $localize`PH - Profile Page - Title` },
          },
          {
            path: UserRoute.Orders,
            component: OrdersComponent,
            data: { title: $localize`PH - My Orders Page - Title` },
          },
          { path: UserRoute.Orders + '/:orderId', component: OrderDetailsComponent },
          { path: UserRoute.Orders + '/cc/:poeOrderId', component: CcOrderDetailsComponent },
          {
            path: UserRoute.Wishlist,
            component: WishlistComponent,
            data: { title: $localize`PH - My Wishlist Page - Title` },
          },
          {
            path: UserRoute.Addresses,
            component: AddressesComponent,
            data: { title: $localize`PH - My Addresses Page - Title` },
          },
          { path: UserRoute.Addresses + '/:addressId', component: AddressEditorComponent },
          {
            path: UserRoute.PaymentMethods,
            component: PaymentMethodsComponent,
            canActivate: [UsaCountryGuardService],
            data: { title: $localize`PH - My Payment Method Page - Title` },
          },
          {
            path: UserRoute.PaymentMethods + '/' + UserRoute.New,
            component: CreatePaymentMethodComponent,
            canActivate: [UsaCountryGuardService],
            data: { title: $localize`PH - New Payment Method Page - Title` },
          },
          {
            path: UserRoute.Recipes,
            component: RecipesComponent,
            data: { title: $localize`PH - Recipes Page - Title` },
          },
          {
            path: UserRoute.Returns,
            component: ReturnsComponent,
            data: { title: $localize`PH - My Returns Page - Title` },
          },
          { path: UserRoute.Returns + '/' + UserRoute.New, component: NewReturnComponent },
          { path: UserRoute.Returns + '/:returnId', component: ReturnDetailsPageComponent },
        ],
        canActivate: [AuthGuardService],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
